import classNames from 'classnames';
import * as React from 'react';
import { useTheme } from '~/Features/Layouts/Theme/Context/ThemeContextProvider';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import { HtmlHeading } from '~/Partials/Controls/HtmlHeading';
import type { IconName } from '~/Partials/SvgIcon/SvgIcon';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import type { Theme } from '~/Utils/Theme';
import styles from './FactCard.module.css';

export interface FactCardProps {
    title?: HtmlString;
    iconName?: IconName;
    content?: HtmlString;
    theme?: Pick<Theme, 'withRoundedCorners'>;
}

export const FactCard: React.FC<FactCardProps> = props => {
    const contextualTheme = useTheme();
    const { title, iconName, content, theme = contextualTheme } = props;

    const { withRoundedCorners } = theme;

    return (
        <div className={classNames(styles.FactCard, withRoundedCorners && styles['Variant--rounded'])}>
            <div className={styles.Heading}>
                {iconName && <SvgIcon className={styles.Icon} iconName={iconName}></SvgIcon>}
                {title && <HtmlHeading type="h3" html={title} className={styles.Title} />}
            </div>
            {content && (
                <HtmlDiv
                    className={classNames(styles.Content, 'RichtextContent', `RichtextContent--dark`)}
                    html={content}
                />
            )}
        </div>
    );
};
